// removed by extract-text-webpack-plugin
module.exports = {"button":"akzId"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabView/TabShareButton/TabShareButton.scss
// module id = ./src/components/TabView/TabShareButton/TabShareButton.scss
// module chunks = 4